import { SectionLabel } from "@/components/Motion";

/* ============================================================
   PASTE THE FINAL APPROVED TERMS & CONDITIONS TEXT BELOW.
   Whatever you put inside the backticks renders EXACTLY as
   written — line breaks, blank lines and indentation are all
   preserved. Do not remove the backticks.

   Shipping, delivery, pause, damaged-order and refund
   information belongs inside this Terms & Conditions text.
   ============================================================ */
const TERMS_AND_CONDITIONS_TEXT = `Terms & Conditions
Last updated: August 2026
Welcome to The Safe Mama Editorial.
The Safe Mama Editorial is a physical editorial publication for pregnancy and motherhood, published by Banyan Editorials, a proprietorship currently in the process of registration in India.
By accessing our website or purchasing The Safe Mama Editorial, you agree to these Terms & Conditions.
1. The Safe Mama Editorial
The Safe Mama Editorial is a physical publication delivered by post in a paper envelope.
Depending on the edition and month, it may include editorial material such as:
An anonymous letter based on the experience of a mother
Postcards from the Indian Kitchen
A Nourishment Weekly Meal Plan
A Thoughtful Surprise
An Expert Note or other professional contribution
Exact content, contributors, surprises, collaborations and presentation may vary between editions.
Images shown on the website may be representative. As this is an evolving editorial publication, individual contents and presentation may change from month to month.
2. Pregnancy & Motherhood Editions
The Safe Mama Editorial currently offers two editions:
Pregnancy Edition
and
Motherhood Edition
Readers select the edition appropriate to them when purchasing.
Where available through our plan-management system, readers may update their edition for future, undispatched envelopes if their stage changes during an active plan.
Changes cannot be applied retrospectively to editions that have already been dispatched.
3. Plans & Pricing
Current purchase options are:
Single Edition — ₹699
3-Month Plan — ₹1,799
Includes three monthly editions.
6-Month Plan — ₹2,999
Includes six monthly editions.
All prices are stated in Indian Rupees unless otherwise specified.
Plans are prepaid, one-time purchases.
They do not automatically renew.
Once all editions included in a plan have been fulfilled, the plan is complete. If you would like to continue receiving The Safe Mama Editorial, you will need to make a new purchase.
We reserve the right to change prices for future purchases. A price change will not alter a plan that has already been purchased and paid for.
4. Payment
Payment must be completed at the time of purchase through the payment methods made available on our website.
Payments may be processed by third-party payment providers such as Razorpay and may also be subject to that provider's terms and policies.
An order is considered confirmed once payment has been successfully received and the order has been accepted.
5. Delivery
The Safe Mama Editorial currently delivers within India only.
We generally aim to dispatch each monthly edition during the last week of the preceding month, so that readers receive their edition approximately during the first or second week of the relevant month.
For example, the September edition would generally be dispatched during the last week of August.
Delivery dates are estimates and may vary depending on destination, courier or postal delays, public holidays, weather, operational circumstances and other events outside our reasonable control.
We will do our best to communicate material delays where reasonably possible.
Readers are responsible for providing complete and accurate delivery information.
6. Changing Your Address or Edition
Readers with active plans should update changes to their delivery address sufficiently before the next edition is prepared or dispatched.
Where available, readers may also change between the Pregnancy and Motherhood Editions for future, undispatched envelopes.
We cannot guarantee that changes submitted after an edition has entered fulfilment can be applied to that month's delivery.
7. Pausing Your Plan
Readers with an active 3-Month or 6-Month Plan may pause future deliveries.
Pausing does not reduce the number of editions you have purchased.
For example, if you purchase six editions, receive two and then pause, the remaining four editions will be held until you resume your plan.
A plan may remain paused for a maximum of 12 months.
If a paused plan is not resumed within 12 months, the plan will expire and any remaining editions will be forfeited.
No refund will be issued for editions forfeited due to expiry following a 12-month pause.
8. Refunds
Purchases of The Safe Mama Editorial are generally non-refundable.
Because editions and multi-month plans are prepared and fulfilled as physical editorial products, we do not ordinarily offer refunds for change of mind, failure to use a plan, or a decision not to continue receiving it.
Where applicable law requires a refund, replacement or other remedy, your statutory rights will continue to apply.
Where appropriate, we are happy to assist with pausing an eligible plan or replacing a damaged or incorrectly supplied edition in accordance with these Terms.
9. Damaged, Incorrect or Missing Deliveries
We want your Safe Mama Editorial to reach you in good condition.
If an edition arrives materially damaged or you receive an incorrect edition, please contact us promptly at:
thesafemamaeditorial@gmail.com
Please include your order information and clear photographic or video evidence showing the issue.
Where the claim is reasonably verified, we may arrange a replacement at no additional cost.
If an expected edition has not arrived within a reasonable period after its expected delivery window, please contact us so that we can investigate the shipment and determine the appropriate resolution.
Replacement is subject to availability and applicable law.
10. Thoughtful Surprises & Brand Collaborations
Some editions may contain a Thoughtful Surprise.
This could include a product sample, food item, skincare item, stationery, stickers, promotional item or another small surprise selected for the edition.
The contents will vary and a branded product sample is not guaranteed in every edition.
Where a product is supplied by a third-party brand, that product may be subject to the manufacturer's own instructions, warnings, ingredients, expiry information and terms of use.
Please review all product information before use, particularly if you have allergies, sensitivities, dietary restrictions or other individual considerations.
11. Editorial, Nutrition & Expert Content
The Safe Mama Editorial may contain information relating to nutrition, pregnancy, postpartum wellbeing, fitness, mental wellbeing, parenting and other aspects of motherhood.
This material is provided for general informational and editorial purposes.
It is not intended to replace personalised medical, nutritional, psychological or other professional advice, diagnosis or treatment.
Pregnancy, postpartum recovery, babies and individual health circumstances vary considerably. Readers should seek appropriate professional advice where required and should not disregard medical advice because of something they have read in The Safe Mama Editorial.
Expert contributions represent the information or perspective provided for that particular editorial context and should not be interpreted as establishing a professional-client relationship between the contributor and the reader.
12. Postcards from the Indian Kitchen & Meal Plans
Recipes and Nourishment Weekly Meal Plans are provided for general informational purposes.
Readers are responsible for considering their own allergies, intolerances, dietary restrictions, medical requirements, food-safety considerations and advice provided by their healthcare professionals.
Ingredients and recommendations may not be appropriate for every reader.
13. The Reading Room & External Content
The Reading Room may curate and link to useful articles and resources published by third parties.
External content remains the property and responsibility of its respective publisher or author.
The Safe Mama Editorial does not claim ownership of third-party articles simply because we recommend or link to them.
A link or recommendation does not necessarily constitute endorsement of every opinion, product or statement contained on the external website.
Third-party websites operate under their own terms and policies.
14. Sharing Your Story
Mothers may voluntarily submit stories or experiences for consideration by The Safe Mama Editorial.
Story submissions are governed by the permissions and consent presented at the point of submission.
Where permission has been provided, a selected story may be edited, rewritten, shortened and anonymised for editorial publication.
We aim to remove or alter identifying details before publishing anonymous stories.
Submission does not guarantee publication.
15. Intellectual Property
Unless otherwise stated, original content created for The Safe Mama Editorial — including its written editorial content, design, branding, graphics, recipes, original photography and other original materials — belongs to Banyan Editorials or is used with appropriate permission.
Content may not be reproduced, republished, commercially distributed or used to create derivative commercial material without permission, except where permitted by applicable law.
Third-party content linked through the Reading Room remains the property of its respective owner.
16. Website Availability
We aim to keep the website accessible and accurate but cannot guarantee uninterrupted or error-free operation.
We may update, modify, temporarily suspend or discontinue website features where reasonably necessary.
17. Changes to These Terms
We may update these Terms & Conditions as The Safe Mama Editorial evolves.
Changes will apply prospectively from the date the updated Terms are published, unless otherwise required by law.
Terms applicable to an already completed purchase will not be retrospectively changed in a way that removes rights already acquired by the reader.
18. Governing Law
These Terms are governed by the laws of India.
Nothing in these Terms limits any rights or remedies available to consumers under applicable Indian consumer-protection law.
19. Contact
For questions about an order, delivery, plan or these Terms, contact:
The Safe Mama Editorial
Published by Banyan Editorials
Email: thesafemamaeditorial@gmail.com
India`;
/* ============================================================
   END OF EDITABLE CONTENT.
   ============================================================ */

export default function TermsAndConditions() {
  return (
    <div className="pt-10 md:pt-16 pb-32" data-testid="terms-and-conditions-page">
      <section className="editorial-container max-w-3xl">
        <SectionLabel number="Legal" label="Terms & Conditions" />
        <h1 className="mt-8 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-ink">
          Terms &amp; Conditions
        </h1>

        <div
          className="mt-14 font-sans text-base md:text-lg leading-[1.75] text-ink/85 whitespace-pre-wrap"
          data-testid="terms-and-conditions-body"
        >
          {TERMS_AND_CONDITIONS_TEXT}
        </div>
      </section>
    </div>
  );
}
